{
  "doka": {
    "labelReset": "Reset",
    "labelDefault": "Default",
    "labelAuto": "Auto",
    "labelNone": "None",
    "labelEdit": "Edit",
    "labelClose": "Close",
    "labelLandscape": "Landscape",
    "labelPortrait": "Portrait",
    "labelSizeExtraSmall": "Extra small",
    "labelSizeSmall": "Small",
    "labelSizeMediumSmall": "Medium small",
    "labelSizeMedium": "Medium",
    "labelSizeMediumLarge": "Medium large",
    "labelSizeLarge": "Large",
    "labelSizeExtraLarge": "Extra large",
    "labelButtonRevert": "Revert",
    "labelButtonCancel": "Cancel",
    "labelButtonUndo": "Undo",
    "labelButtonRedo": "Redo",
    "labelButtonExport": "Done",
    "statusLabelButtonClose": "Close",
    "cropLabel": "Crop",
    "cropLabelButtonRecenter": "Recenter",
    "cropLabelButtonRotateLeft": "Rotate left",
    "cropLabelButtonRotateRight": "Rotate right",
    "cropLabelButtonFlipHorizontal": "Flip horizontal",
    "cropLabelButtonFlipVertical": "Flip vertical",
    "cropLabelSelectPreset": "Crop shape",
    "cropLabelCropBoundary": "Crop boundary",
    "cropLabelCropBoundaryEdge": "Edge of image",
    "cropLabelCropBoundaryNone": "None",
    "cropLabelTabRotation": "Rotation",
    "cropLabelTabZoom": "Zoom",
    "filterLabel": "Filter",
    "filterLabelChrome": "Chrome",
    "filterLabelFade": "Fade",
    "filterLabelCold": "Cold",
    "filterLabelWarm": "Warm",
    "filterLabelPastel": "Pastel",
    "filterLabelMonoDefault": "Mono",
    "filterLabelMonoNoir": "Noir",
    "filterLabelMonoWash": "Wash",
    "filterLabelMonoStark": "Stark",
    "filterLabelSepiaDefault": "Sepia",
    "filterLabelSepiaBlues": "Blues",
    "filterLabelSepiaRust": "Rust",
    "filterLabelSepiaColor": "Color",
    "finetuneLabel": "Finetune",
    "finetuneLabelBrightness": "Brightness",
    "finetuneLabelContrast": "Contrast",
    "finetuneLabelSaturation": "Saturation",
    "finetuneLabelExposure": "Exposure",
    "finetuneLabelTemperature": "Temperature",
    "finetuneLabelGamma": "Gamma",
    "finetuneLabelClarity": "Clarity",
    "finetuneLabelVignette": "Vignette",
    "imageTooSmall": "This image is too small. Please upload one that's at least {minLongSide}×{minShortSide} pixels (landscape or portrait)",
    "imageTooLarge": "This image is too large. Please upload one that's {maxSizeMb} MB or smaller.",
    "imageCropBelowSource": "This crop is too small and would reduce photo quality. Use the full image area or upload a higher resolution photo.",
    "imageReadError": "We could not read that image. Try a different file or format.",
    "notSupportedOnThisBrowser": "not supported on this browser",
    "waitingForImage": "Waiting for image",
    "errorLoadingImage": "Error loading image",
    "creatingPreview": "Creating preview…",
    "loadingImage": "Loading image…",
    "errorUploadingImage": "Error uploading image",
    "uploadingImage": "Uploading image…",
    "errorProcessingImage": "Error processing image",
    "processingImage": "Processing image…",
    "unsupportedType": "Filetype {extension} is not supported. Allowed types: {extensions}"
  }
}
